import { useTranslation } from 'react-i18next';

import styles from './SliderPlayPauseButton.module.css';

type SliderPlayPauseButtonProps = {
  isRunning: boolean;
  onToggle: () => void;
  disabled: boolean;
};

const SliderPlayPauseButton = ({ isRunning, onToggle, disabled }: SliderPlayPauseButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={styles.playPauseBtn}
      aria-label={isRunning ? t('slider.pause') : t('slider.play')}
      onClick={onToggle}
      disabled={disabled}
    >
      <i
        aria-hidden="true"
        className={`totem-icon ${isRunning ? 'totem-icon-pause' : 'totem-icon-play'} ${styles.playPauseIcon}`}
      />
    </button>
  );
};

export default SliderPlayPauseButton;
